/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputWeatherCoverage } from './OutputWeatherCoverage';
import {
    OutputWeatherCoverageFromJSON,
    OutputWeatherCoverageFromJSONTyped,
    OutputWeatherCoverageToJSON,
} from './OutputWeatherCoverage';
import type { OutputWeatherGrid } from './OutputWeatherGrid';
import {
    OutputWeatherGridFromJSON,
    OutputWeatherGridFromJSONTyped,
    OutputWeatherGridToJSON,
} from './OutputWeatherGrid';
import type { OutputWeatherIngest } from './OutputWeatherIngest';
import {
    OutputWeatherIngestFromJSON,
    OutputWeatherIngestFromJSONTyped,
    OutputWeatherIngestToJSON,
} from './OutputWeatherIngest';
import type { OutputWeatherLayer } from './OutputWeatherLayer';
import {
    OutputWeatherLayerFromJSON,
    OutputWeatherLayerFromJSONTyped,
    OutputWeatherLayerToJSON,
} from './OutputWeatherLayer';
import type { OutputWeatherQuota } from './OutputWeatherQuota';
import {
    OutputWeatherQuotaFromJSON,
    OutputWeatherQuotaFromJSONTyped,
    OutputWeatherQuotaToJSON,
} from './OutputWeatherQuota';
import type { OutputWeatherRun } from './OutputWeatherRun';
import {
    OutputWeatherRunFromJSON,
    OutputWeatherRunFromJSONTyped,
    OutputWeatherRunToJSON,
} from './OutputWeatherRun';

/**
 * 
 * @export
 * @interface OutputWeatherStatus
 */
export interface OutputWeatherStatus {
    /**
     * 
     * @type {OutputWeatherCoverage}
     * @memberof OutputWeatherStatus
     */
    coverage?: OutputWeatherCoverage;
    /**
     * 
     * @type {OutputWeatherGrid}
     * @memberof OutputWeatherStatus
     */
    grid?: OutputWeatherGrid;
    /**
     * 
     * @type {OutputWeatherIngest}
     * @memberof OutputWeatherStatus
     */
    ingest?: OutputWeatherIngest;
    /**
     * 
     * @type {Array<OutputWeatherLayer>}
     * @memberof OutputWeatherStatus
     */
    layers?: Array<OutputWeatherLayer>;
    /**
     * 
     * @type {OutputWeatherQuota}
     * @memberof OutputWeatherStatus
     */
    quota?: OutputWeatherQuota;
    /**
     * 
     * @type {Array<OutputWeatherRun>}
     * @memberof OutputWeatherStatus
     */
    runs?: Array<OutputWeatherRun>;
}

/**
 * Check if a given object implements the OutputWeatherStatus interface.
 */
export function instanceOfOutputWeatherStatus(value: object): boolean {
    return true;
}

export function OutputWeatherStatusFromJSON(json: any): OutputWeatherStatus {
    return OutputWeatherStatusFromJSONTyped(json, false);
}

export function OutputWeatherStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWeatherStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'coverage': json['coverage'] == null ? undefined : OutputWeatherCoverageFromJSON(json['coverage']),
        'grid': json['grid'] == null ? undefined : OutputWeatherGridFromJSON(json['grid']),
        'ingest': json['ingest'] == null ? undefined : OutputWeatherIngestFromJSON(json['ingest']),
        'layers': json['layers'] == null ? undefined : ((json['layers'] as Array<any>).map(OutputWeatherLayerFromJSON)),
        'quota': json['quota'] == null ? undefined : OutputWeatherQuotaFromJSON(json['quota']),
        'runs': json['runs'] == null ? undefined : ((json['runs'] as Array<any>).map(OutputWeatherRunFromJSON)),
    };
}

export function OutputWeatherStatusToJSON(value?: OutputWeatherStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'coverage': OutputWeatherCoverageToJSON(value['coverage']),
        'grid': OutputWeatherGridToJSON(value['grid']),
        'ingest': OutputWeatherIngestToJSON(value['ingest']),
        'layers': value['layers'] == null ? undefined : ((value['layers'] as Array<any>).map(OutputWeatherLayerToJSON)),
        'quota': OutputWeatherQuotaToJSON(value['quota']),
        'runs': value['runs'] == null ? undefined : ((value['runs'] as Array<any>).map(OutputWeatherRunToJSON)),
    };
}

